<template>
  <div v-if="body_show">
    <div class="task_f task_fqa">
      <h4 v-html="faq_content.content"></h4>
    </div>
  </div>
</template>
<script>
import {
  getfaq
} from "@/api/course";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        cid: "",
        pid: "",
        body_show: false,
        faq_content: {},
        type_obj: {}
      }
    },
    methods: {
      pullData() {
        getfaq({
            type: "self",
            cid: this.$route.query.cid,
            id: this.$route.query.id
          })
          .then((data) => {
            this.body_show = true;
            this.faq_content = data;
            document.title = data.coursename;
            this.type_obj= {
              type_title: data.name
            }
            // 神策统计--查看项目攻略时
            sensors.track('projectStrategy', {
              course_id: this.$route.query.cid,
              course_name: data.coursename,
              project_id: String(data.cpid),
              project_name: data.projectname,
              strategy_name: data.name,
            });
            shareCon("course",this,this.type_obj);
          })

      }
    },
    created() {
      this.pullData();

    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.task_f {
  padding: 0 changeRem(.6)+px;
  margin: 0 auto;
  margin-top: changeRem(.8)+px;
  text-align: left;
}
</style>
